import { render, staticRenderFns } from "./Skift.vue?vue&type=template&id=9e25877e"
import script from "./Skift.vue?vue&type=script&lang=js"
export * from "./Skift.vue?vue&type=script&lang=js"
import style0 from "./Skift.vue?vue&type=style&index=0&id=9e25877e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports